import axiosInstance from "auth/FetchInterceptor";

const PREFIX = "/en/api/v1.0";
const DINH_BIEN_API = `${PREFIX}/DinhBien`;

const DinhBienService = {};

// --- Loại cơ sở ---
DinhBienService.getAllLoai = function () {
  return axiosInstance.get(`${DINH_BIEN_API}/loai/get-all`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.upsertLoai = function (data) {
  return axiosInstance.post(`${DINH_BIEN_API}/loai/upsert`, data, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.deleteLoai = function (id) {
  return axiosInstance.delete(`${DINH_BIEN_API}/loai?id=${id}`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

// --- Quy mô ---
DinhBienService.getAllQuyMo = function () {
  return axiosInstance.get(`${DINH_BIEN_API}/quy-mo/get-all`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.upsertQuyMo = function (data) {
  return axiosInstance.post(`${DINH_BIEN_API}/quy-mo/upsert`, data, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.deleteQuyMo = function (id) {
  return axiosInstance.delete(`${DINH_BIEN_API}/quy-mo?id=${id}`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

// --- Khoa phòng ---
DinhBienService.getAllKhoaPhong = function () {
  return axiosInstance.get(`${DINH_BIEN_API}/khoa-phong/get-all`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.upsertKhoaPhong = function (data) {
  return axiosInstance.post(`${DINH_BIEN_API}/khoa-phong/upsert`, data, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.deleteKhoaPhong = function (id) {
  return axiosInstance.delete(`${DINH_BIEN_API}/khoa-phong?id=${id}`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

// --- Định biên (bệnh viện / phòng khám) ---
DinhBienService.getDinhBienBenhVien = function (quyMoId) {
  return axiosInstance.get(
    `${DINH_BIEN_API}/benh-vien?quyMoId=${quyMoId ?? ""}`,
    { baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL }
  );
};

DinhBienService.getDinhBienPhongKham = function () {
  return axiosInstance.get(`${DINH_BIEN_API}/phong-kham`, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

DinhBienService.upsertDinhBienRow = function (data) {
  return axiosInstance.post(`${DINH_BIEN_API}/upsert-row`, data, {
    baseURL: process.env.REACT_APP_HRM_ENDPOINT_URL,
  });
};

export default DinhBienService;
